import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Outlet, useOutletContext } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "./components/ui/sonner";
import { ContentProvider } from "./lib/content";
import { useLenis, scrollTop } from "./lib/smooth";
import { Navbar } from "./components/site/Navbar";
import { Footer } from "./components/site/Footer";
import { WhatsAppButton } from "./components/site/WhatsAppButton";
import { CookieBanner } from "./components/site/CookieBanner";
import { TrackingManager } from "./components/site/TrackingManager";
import Home, { useCases } from "./pages/Home";
import Programma from "./pages/Programma";
import Privacy from "./pages/Privacy";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";

const SiteLayout = () => {
  const cases = useCases();
  const { pathname, hash } = useLocation();
  useLenis(true);
  useEffect(() => { if (!hash) scrollTop(); }, [pathname, hash]);
  return (
    <div className="relative min-h-screen bg-[#060a14] overflow-x-clip">
      <Navbar hasCases={cases.length > 0} />
      <Outlet context={{ cases }} />
      <Footer />
      <WhatsAppButton />
      <CookieBanner />
      <TrackingManager />
    </div>
  );
};

const HomeRoute = () => {
  const ctx = useOutletContext();
  return <Home cases={ctx?.cases || []} />;
};

function App() {
  return (
    <ContentProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<HomeRoute />} />
            <Route path="/programma" element={<Programma />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="*" element={<HomeRoute />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors />
    </ContentProvider>
  );
}

export default App;
